import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Radio from '../Radio';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles);
function RadioControl(_ref) {
  let {
    children,
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    option,
    onChange,
    onBlur,
    value,
    isReadOnly,
    ...props
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  // Overrides
  const override = getOverrides(overridesProp, RadioControl.overrides);
  const {
    value: optionValue,
    overrides: optionOverrides,
    label,
    ...optionProps
  } = option;
  const onChangeRadio = useCallback(e => {
    e.stopPropagation();
    onChange && onChange(optionValue, e);
    onBlur && onBlur(optionValue);
  }, [onBlur, onChange, optionValue]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNameProp,
    onClick: isReadOnly ? undefined : onChangeRadio
  }, override.radioControl), /*#__PURE__*/React.createElement(Radio, _extends({}, props, optionProps, {
    checked: value === optionValue,
    isDisabled: isReadOnly,
    overrides: {
      ...overridesProp.radio,
      ...optionOverrides
    }
  })), /*#__PURE__*/React.createElement("span", _extends({
    className: classes.radioLabel
  }, override.radioLabel), label));
}
RadioControl.overrides = ['radioLabel', 'radioControl'];
RadioControl.defaultProps = {
  onChange: () => {},
  option: {},
  isReadOnly: false
};
process.env.NODE_ENV !== "production" ? RadioControl.propTypes = {
  overrides: PropTypes.object,
  onChange: PropTypes.func,
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  }),
  value: PropTypes.any,
  isReadOnly: PropTypes.bool
} : void 0;
export default /*#__PURE__*/React.memo(RadioControl);